import React from 'react';
import AssignmentResources from 'legacy/src/components/assignment/AssignmentResources';
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';

/**
 * Draws the single student resources
 * */
const SingleStudentResources = (props) => {
  const {
    tagPairsData: {
      assignmentProgressWithTagPairs: {
        tagPairAbbreviations = { items: '' },
        otherParts,
      },
    },
    studentContext,
  } = props;

  const teacherTagAbbreviations = uniq(
    flatten([
      ...Object.values(tagPairAbbreviations),
      ...otherParts.map(({ tagPairAbbreviations }) => tagPairAbbreviations),
    ]),
  );

  return (
    <AssignmentResources
      {...props}
      studentContext={{
        ...studentContext,
        teacherTagAbbreviations,
      }}
    />
  );
};

export default SingleStudentResources;
